import React from 'react';
import './about.scss';
import "yet-another-react-lightbox/styles.css";
import appConfig from '../../app-config';

export default class About extends React.Component {
  render() {
    return (
      <React.Fragment>
        <div className='fp-about-block'>
          <p className='fp-about-block-paragraph'>Welcome to {appConfig.app.title}!</p>
          <p>My name is <strong>Frederic</strong>, and I’m an enthusiastic photographer with a passion for capturing the world around me. My photography interests span sports, automotive, landscapes, and street photography, as well as the places and moments I encounter while traveling.</p>
          <p>I’ve been passionate about photography since I was a teenager, and over the years it has grown from a hobby into a creative pursuit that I truly enjoy. For me, photography is about more than simply taking a picture—it’s about capturing a moment, finding an interesting perspective, and telling a story through an image.</p>
          <p>Today, I shoot exclusively with my <strong>Nikon D850</strong>, a camera I absolutely love. Rather than constantly chasing the latest technology, I’ve chosen to focus on mastering the equipment I have and continuing to improve my photography.</p>
          <p><strong>FP Digital Photo</strong> is where I share my work, my travels, and the subjects that inspire me—from fast-moving sports and beautiful cars to dramatic landscapes and everyday moments on the street.</p>
          <p>Thanks for visiting, and I hope you enjoy exploring my photography!</p>
        </div>
      </React.Fragment>
    )
  }
};